// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
import * as Untagged_TypeCheck from "../Untagged.TypeCheck/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var DocumentUploadFileName = function (x) {
    return x;
};
var tsBridgeDocumentUploadFil = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("DocumentUploadFileName")("__brandDocumentUploadFileName"));
    }
};
var writeDocumentUploadFileName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showDocumentUploadFileName = Data_Show.showString;
var readDocumentUploadFileName = Simple_JSON.readString;
var ordDocumentUploadFileName = Data_Ord.ordString;
var newtypeDocumentUploadFileName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeDocumentUploadFileName = DocumentUploadFileName;
var hasRuntimeTypeDocumentUploadFileName = Untagged_TypeCheck.hasRuntimeTypeString;
var eqDocumentUploadFileName = Data_Eq.eqString;
export {
    DocumentUploadFileName,
    makeDocumentUploadFileName,
    unwrap,
    newtypeDocumentUploadFileName,
    eqDocumentUploadFileName,
    ordDocumentUploadFileName,
    showDocumentUploadFileName,
    readDocumentUploadFileName,
    writeDocumentUploadFileName,
    hasRuntimeTypeDocumentUploadFileName,
    tsBridgeDocumentUploadFil
};
//# sourceMappingURL=index.js.map
